<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/16v9rTn/tc-custom/9781466868762.jpg?1728326945694" alt="This image is the cover for the book Survival, Star Quest Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Survival, Star Quest Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <p>Ben Bova continues his hard SF Star Quest series which began with <i>Death Wave</i> and <i>Apes and Angels</i>. <br/><br/><b>Best New Science Fiction and Fantasy Books for December—</b><b><i>io9</i></b><b><br/>Science Fiction and Fantasy Books to Read This December—</b><b><i>The Verge</i></b><b><br/>Best SFF of December—</b><b><i>Unbound Worlds</i></b><br/><br/>In <i>Surivival</i>, a human team sent to scout a few hundred lightyears in front of the death wave encounters a civilization far in advance of our own, a civilization of machine intelligences. <br/><br/>These sentient, intelligent machines have existed for eons, and have survived earlier “death waves,” gamma ray bursts from the core of the galaxy. They are totally self-sufficient, completely certain that the death wave cannot harm them, and utterly uninterested in helping to save other civilizations, organic or machine.<br/><br/>But now that the humans have discovered them, they refuse to allow them to leave their planet, reasoning that other humans will inevitably follow if they learn of their existence.<br/><br/>The Star Quest Trilogy<br/>#1 Death Wave<br/>#2 Apes and Angels<br/>#3 Survival<br/><br/>At the Publisher's request, this title is being sold without Digital Rights Management Software (DRM) applied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Ben Bova
      </h2>
      
      <p class="authorDescription body article"><P><B>Ben Bova</B> (1932-2020) was the author of more than a hundred works of science fact and fiction, including <I>Able One, Transhuman, Orion</I>, the Star Quest Trilogy, and the Grand Tour novels, including <I>Titan</I>, winner of John W. Campbell Memorial Award for best novel of the year. His many honors include the Isaac Asimov Memorial Award in 1996, the Lifetime Achievement Award of the Arthur C. Clarke Foundation in 2005, and the Robert A. Heinlein Award “for his outstanding body of work in the field of literature” in 2008.<br><br>Dr. Bova was President Emeritus of the National Space Society and a past president of Science Fiction Writers of America, and a former editor of <I>Analog</I> and former fiction editor of <I>Omni</I>. As an editor, he won science fiction’s Hugo Award six times. His writings predicted the Space Race of the 1960s, virtual reality, human cloning, the Strategic Defense Initiative (Star Wars), electronic book publishing, and much more.<br><br>In addition to his literary achievements, Bova worked for Project Vanguard, America’s first artificial satellite program, and for Avco Everett Research Laboratory, the company that created the heat shields for Apollo 11, helping the NASA astronauts land on the moon. He also taught science fiction at Harvard University and at New York City’s Hayden Planetarium and worked with such filmmakers as George Lucas and Gene Roddenberry.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Tom Doherty Associates
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?674d7648